import { Component } from '@angular/core';
import { ValidationService } from 'src/app/service/validation.service';
import { ResponseStatus } from 'src/enum/responseEnum';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { ProductListingService } from 'src/app/service/product-listing.service';
import { RegisterService } from 'src/app/service/register.service';
import { DatePipe } from '@angular/common';
import { UtilityService } from 'src/app/service/utility.service';
import { Router } from '@angular/router';
import { PageStateService } from 'src/app/service/page-state.service';

@Component({
  selector: 'app-validation-listing',
  templateUrl: './validation-listing.component.html',
  styleUrls: ['./validation-listing.component.css'],
})
export class ValidationListingComponent {
  title1 = 'Admin Panel';
  title = 'Business Validation';
  class1 = 'profile-banner ';
  img1 = '../../../assets/images/logo.png';
  validationList: any = [];
  products: any[] = [];
  currentPage: number = 1;
  pageLimit: number = 5;
  totalRecords: number = 0;
  loading: boolean = true;
  searchProduct: string = '';
  filterForm: any = FormGroup;

  approveLoader: boolean = false;
  rejectLoader: boolean = false;
  approvedOnly: boolean = false;
  statusWorkFlow : any[] = [];

  searchProductVal: string = '';

  defaultFilterValues: any = {
    entityTypeIn: [''],
    dateFrom: [''],
    dateTo: [''],
    statusIn: [''],
    categoryIn: [''],
  };

  categoryList: any = {
    loading: false,
    response: null,
    error: '',
  };
  productTypes: any = {
    loading: false,
    response: null,
    error: '',
  };
  productStatus: any = {
    loading: false,
    response: null,
    error: '',
  };

  pickDates: any = null;
  RegDates: any = null

  constructor(
    private validationService: ValidationService,
    private fb: FormBuilder,
    private utility: UtilityService,
    private register: RegisterService,
    private datePipe: DatePipe,
    private router: Router,
    private productListingService: ProductListingService,
    private pageStateService: PageStateService
  ) {

    this.filterForm = this.fb.group(this.defaultFilterValues);
    this.getUserInfo();
    this.fetchAllBusinessWorkFlow();
    if (this.approvedOnly) {
      this.filterForm.get('status').setValue(14); // for approved only right now we have status id as 14 it may change in future
      this.title = 'Approved <span>Products</span>';
    }
    this.getProductCategories();
    this.getProductTypes();

  }

  ngOnInit() {
    this.currentPage = this.pageStateService.getCurrentPage();
    this.pageLimit = this.pageStateService.getPageLimit();
    this.getMaritalStatus();
  }
  onPageChange(page: any) {
    this.currentPage = page;
    this.pageStateService.setCurrentPage(page);
    // this.getMaritalStatus();
    this.getProductList();
  }

  onPageSizeChange(page: any) {
    this.pageLimit = page;
    this.currentPage = 1;
    this.pageStateService.setCurrentPage(this.currentPage);
    this.pageStateService.setPageLimit(page);
    // this.getMaritalStatus();
    this.getProductList();
  }


  fetchAllBusinessWorkFlow(){
    this.validationService.fetchAllBusinessWorkFlow().then(res =>{
      if(res.status == 'SUCCESS'){
        this.statusWorkFlow = res.data;
        this.getProductStatus();
      }
    })
  }
  getCurrentStatus(statusWorkFlow : any[], statusId : any){
   return statusWorkFlow.filter( data => data.fromStatusId == statusId && (data.groupBy === 'INLINE'));
  }


  updateStatusOfBusiness(eve:any, business: any){
    let statusId = eve.target.value;
    let id = business.id
    this.validationService.updateStatusOfBusiness(statusId, id).then(res =>{
      if(res.status == 'SUCCESS'){
      window.location.reload();
      }
    })
  }

  getProductCategories() {
    this.categoryList = {
      ...this.categoryList,
      loading: true,
      error: '',
    };
    this.productListingService
      .getBusinessCategories()
      .then((res: any) => {
        this.categoryList = {
          ...this.categoryList,
          loading: false,
          response: res.data.data,
        };
      })
      .catch((err: any) => {
        this.categoryList = {
          ...this.categoryList,
          loading: false,
          response: null,
          error: err.response.statusText,
        };
      });
  }

  handleFilter() {
    this.searchProduct = '';
    this.currentPage = 1;
    this.getProductList();
  }

  getProductTypes() {
    this.productTypes = {
      ...this.productTypes,
      loading: true,
      error: '',
    };
    this.productListingService
      .getProdEntityType()
      .then((res: any) => {
        this.productTypes = {
          ...this.productTypes,
          loading: false,
          response: res.data.data,
        };
      })
      .catch((err: any) => {
        this.productTypes = {
          ...this.productTypes,
          loading: false,
          response: null,
          error: err.response.statusText,
        };
      });
  }

  getProductStatus() {
    this.productStatus = {
      ...this.productStatus,
      loading: true,
      error: '',
    };
    this.productListingService
      .getProductStatusForBusiness()
      .then((res: any) => {
        // const r =  res.data.data.filter((elem : any) => this.statusWorkFlow.find(({ toStatusId }) => elem.id === toStatusId));
        const r =  res.data.records;
        this.productStatus = {
          ...this.productStatus,
          loading: false,
          response: r,
        };
      })
      .catch((err: any) => {
        this.productStatus = {
          ...this.productStatus,
          loading: false,
          response: null,
          error: err.response.statusText,
        };
      });
  }

  resetFilter() {
    this.filterForm.get('entityTypeIn').setValue('');
    this.filterForm.get("dateFrom").setValue("");
    this.filterForm.get("dateTo").setValue("");
    this.filterForm.get('categoryIn').setValue('');
    if (this.approvedOnly) {
      this.filterForm.get('statusIn').setValue(14); // for approved only right now we have status id as 14 it may change in future
    } else {
      this.filterForm.get('statusIn').setValue('');
    }
    this.getProductList();
    this.currentPage = 1;
    this.searchProduct = '';
  }

  getMaritalStatus() {
    this.loading = true;
    this.validationService
      .fetchValidationList((this.currentPage - 1) * this.pageLimit, this.pageLimit)
      .then((res) => {
        if (res.status === ResponseStatus.SUCCESS) {
          this.validationList = res.records;
          this.totalRecords = res.totalRecords;
          this.loading = false;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }


  convertRegDatesToString(regDates: any) {
    if (regDates && regDates.startDate && regDates.endDate) {
        // Convert the Dayjs objects to your desired date format (e.g., ISO string)
        const startDt = regDates.startDate.format('YYYY-MM-DD');
        const endDt = regDates.endDate.format('YYYY-MM-DD');

        // Log the extracted values
        console.log('Start Date:', startDt);
        console.log('End Date:', endDt);

        // Return an object with the converted startDt and endDt
        return {
            startDt: startDt,
            endDt: endDt
        };
    }

    // If regDates is not an object or not in the expected format, return it as is
    return regDates;
  }


  getProductList() {
    console.log('Input control value:', this.filterForm.value.dateFrom);
    console.log('Input control value:', this.RegDates);


    const pDate = new Date(this.filterForm.value.dateFrom);
    const year = pDate.getFullYear();
    const month = String(pDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so we add 1
    const day = String(pDate.getDate()).padStart(2, '0');
    const formattedPDate = `${year}-${month}-${day}`;

    // const regDatesConverted = this.convertRegDatesToString(this.filterForm.value.dateFrom);

    const x: any = {
    
      // regDate: this.filterForm.value.publishedAt ? formattedPDate : '',
      ...(this.filterForm.value?.statusIn && this.filterForm.value?.statusIn.length > 0 ? { statusIn: this.filterForm.value?.statusIn } : {}),
      ...(this.filterForm.value?.entityTypeIn && this.filterForm.value?.entityTypeIn.length > 0 ? { entityTypeIn: this.filterForm.value?.entityTypeIn } : {}),
      ...(this.filterForm.value?.categoryIn && this.filterForm.value?.categoryIn.length > 0 ? { categoryIn: this.filterForm.value?.categoryIn } : {}),
      ...(this.filterForm.value.dateFrom
        ? { dateFromGrEq: this.utility.dateFormatter(this.filterForm.value.dateFrom) }
        : {}),
      ...(this.filterForm.value.dateTo
        ? { dateToLsEq: this.utility.dateFormatter(this.filterForm.value.dateTo) }
        : {}),
    };






    this.validationService
      .fetchValidationListWithBody(
        this.searchProduct,
        this.currentPage,
        this.pageLimit,
        x
      )
      .then((res: any) => {
        this.validationList = res.data.records;
        this.totalRecords = res.data?.totalRecords;
        this.loading = false;
      })
      .catch((err: any) => {
        this.loading = false;
        this.validationList = [];
      });
  }



  getUserInfo() {
    this.register
      .fetchUserDetails()
      .then((res) => {
        if (res.status === ResponseStatus.SUCCESS) {
          let user = res.data.user;
          if(user.roleName == "AMDIN"){
            this.title1 = "Admin Panel";
          }else{
            this.title1 = "Business Validation";
          }
        }
      });
  }


  searchProductOnChange(event: any) {
    // if (value.target.value) {
    //   this.currentPage = 1;
    //   this.searchProduct = value.target.value;
    // }
    // else {
    //   this.searchProduct = "";
    // }

    const val = event.target.value;
    this.currentPage = 1;
    this.searchProduct = val;

    this.getProductList();
  }

  clearSearch() {
    this.searchProduct = '';
    this.getProductList();
  }

  navigateToValidationDetails(ValidateId: number, statusId: number) {
    this.validationService.setStatusId(statusId);
    this.router.navigate(['/validation-details', ValidateId, 1]);
    console.log(statusId)
  }

}
